import React, { useEffect, useState } from "react";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
const AdmissionResultAnalysisReport = () => {
  const [admissionData, setAdmissionData] = useState([]);
  const [resultData, setResultData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReportData();
  }, []);

  const fetchReportData = () => {
    const url = `${config.url.FAC_URL}getAdmissionDtls`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          // Admission details
          if (res.data.admission_status && Array.isArray(res.data.admission)) {
            setAdmissionData(res.data.admission);
          }
          // Result analysis details
          if (res.data.result_status && Array.isArray(res.data.result)) {
            setResultData(res.data.result);
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching report data:", err);
        setLoading(false);
      });
  };

  if (loading) {
    return <div className="text-center mt-5">Loading report...</div>;
  }

  return (
    <div className="report-container p-4">
      {/* <div className="text-center mb-5">
        <h2>Admission & Result Analysis Report</h2>
        <p className="text-muted">Generated on {new Date().toLocaleDateString()}</p>
      </div> */}

      {/* ========== ADMISSION SECTION ========== */}
      {/* <h4 className="mb-3"></h4> */}
      <h5 className="mt-5 mb-3 innerheader-new">
        <span>Admission Details</span>
      </h5>
      <div className="table-responsive mb-5">
        <table className="table table-bordered table-info">
          <thead className="table-info">
            <tr>
              <th rowSpan="2">Sl.No</th>
              <th rowSpan="2">Academic Program Type</th>
              <th rowSpan="2">Branch/Specialization</th>
              <th colSpan="3">Sanctioned Intake</th>
              <th colSpan="3">Admitted</th>
              <th colSpan="3">% Admissions</th>
              <th colSpan="4">III year students (AY 2025-26)</th>
            </tr>
            <tr>
              <th>I Yr</th><th>II Yr</th><th>III Yr</th>
              <th>I Yr</th><th>II Yr</th><th>III Yr</th>
              <th>I Yr</th><th>II Yr</th><th>III Yr</th>
              <th>5th Sem (No.)</th><th>5th Sem (%)</th>
              <th>6th Sem (No.)</th><th>6th Sem (%)</th>
            </tr>
          </thead>
          <tbody>
            {admissionData.length === 0 ? (
              <tr><td colSpan="14" className="text-center">No admission data found</td></tr>
            ) : (
              admissionData.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.stream_name || "-"}</td>
                  <td>{item.single_major_name || "-"}</td>
                  <td>{item.sanctioned_intake_year1 ?? "-"}</td>
                  <td>{item.sanctioned_intake_year2 ?? "-"}</td>
                  <td>{item.sanctioned_intake_year3 ?? "-"}</td>
                  <td>{item.admitted_year1 ?? "-"}</td>
                  <td>{item.admitted_year2 ?? "-"}</td>
                  <td>{item.admitted_year3 ?? "-"}</td>
                  <td>{item.admission_percent_year1 ?? "-"}</td>
                  <td>{item.admission_percent_year2 ?? "-"}</td>
                  <td>{item.admission_percent_year3 ?? "-"}</td>
                  <td>{item.sem5_students ?? "-"}</td>
                  <td>{item.sem5_percent ?? "-"}</td>
                  <td>{item.sem6_students ?? "-"}</td>
                  <td>{item.sem6_percent ?? "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ========== RESULT ANALYSIS SECTION ========== */}
      {/* <h4 className="mb-3">Result Analysis (last three academic years)</h4> */}
      <h5 className="mt-5 mb-3 innerheader-new">
        <span>Result Analysis for Final Year Students(last three academic years)</span>
      </h5>
      <div className="table-responsive">
        <table className="table table-bordered table-success">
          <thead className="table-success">
            <tr>
              <th rowSpan="2">Sl.No</th>
              <th rowSpan="2">Academic Program Type</th>
              <th rowSpan="2">Branch/Specialization</th>
              {/* <th colSpan="3">2020-2023</th> */}
              <th colSpan="3">2021-2024</th>
              <th colSpan="3">2022-2025</th>
            </tr>
            <tr>
              {/* <th>Appeared</th><th>Passed</th><th>Pass %</th> */}
              <th>Appeared</th><th>Passed</th><th>Pass%</th>
              <th>Appeared</th><th>Passed</th><th>Pass%</th>
            </tr>
          </thead>
          <tbody>
            {resultData.length === 0 ? (
              <tr><td colSpan="11" className="text-center">No result data found</td></tr>
            ) : (
              resultData.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.stream_name || "-"}</td>
                  <td>{item.ug_programme_name || "-"}</td>
                  {/* <td>{item.appeared_year20_23 ?? "-"}</td>
                  <td>{item.passed_year20_23 ?? "-"}</td>
                  <td>{item.percent_year20_23 ?? "-"}</td> */}
                  <td>{item.appeared_year21_24 ?? "-"}</td>
                  <td>{item.passed_year21_24 ?? "-"}</td>
                  <td>{item.percent_year21_24 ?? "-"}</td>
                  <td>{item.appeared_year22_25 ?? "-"}</td>
                  <td>{item.passed_year22_25 ?? "-"}</td>
                  <td>{item.percent_year22_25 ?? "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <style>{`
        .report-container {
          background: white;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        @media print {
          .report-container {
            padding: 0;
          }
          .table-bordered th, .table-bordered td {
            border: 1px solid #000 !important;
          }
          .table-striped tbody tr:nth-of-type(odd) {
            background-color: #f2f2f2 !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AdmissionResultAnalysisReport;